<script>

import Service from '../../../services/equipment-operation';

import Card from 'primevue/card';
import Calendar from 'primevue/calendar';
import InputNumber from 'primevue/inputnumber';
import Button from 'primevue/button';
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import CommonConstants from '../../../common/Constants';
import Utils from '../../../common/Utils';
import GenericCustomAutocompleteV2 from '../../generic/GenericCustomAutocompleteV2.vue'

export default{
    setup: () => ({ v$: useVuelidate() }),
    components: {
        Card, Calendar, InputNumber, Button,
        GenericCustomAutocompleteV2
    },
    validations(){
        return {
            data: {
                tankCode: {required},
                calculationDate: {required}
            }
        }
    },
    data(){
        return {
            submitted: false,
            tankSelected: null,
            isGas: false,
            data: {
                tankCode: null,
                calculationDate: null,
                inService: true,
                productId: null,
                density15: null,
                gasPressure: null,
                gasTemperature: null,
                molecularWeight: null,
                measureType: 'Full',
                productLevel: null,
                feetPosition: 'D',
                calibrationTemperature: null,
                gasPressureBar: null,
                gasPressureKGCM2: null
            }
        }
    },
    methods: {
        importFromPI(){
            this.submitted = true;
            if(!this.v$.$invalid){
                this.$store.dispatch("generic/setLoading", true);
                Service.importFromPI({date: this.data.calculationDate, tank: this.data.tankCode}, ({success, data, message}) =>{
                    this.$store.dispatch("generic/setLoading", false);
                    if(success){
                        this.data.environmentTemperature = null;
                        this.data.productLevel = null;
                        this.data.temperature = null;
                        this.data.density15 = null;
                        this.data.gasPressureBar = null;
                        this.data.gasPressureKGCM2 = null;
                        this.data.gasTemperature = null;
                        
                        data.reverse().forEach(({items}) => {
                            const [{description, value, uoM}] = items;
                            // const key = {
                            // 'EnvironmentTemperature': 'environmentTemperature',
                            // 'Level': 'productLevel',
                            // 'Temperature': 'temperature',
                            // 'Density': 'density15',
                            // 'Pressure': 'gasPressure',
                            // 'Gas Temperature': 'gasTemperature'
                            // }?.[description];
                            // key && (this.data[key] = value);
                            switch(description){
                                case 'EnvironmentTemperature':
                                    this.data.environmentTemperature = value;
                                break;
                                case 'Level':
                                    this.data.productLevel = value;
                                break;
                                case 'Temperature':
                                    this.data.temperature = value;
                                break;
                                case 'Density':
                                    this.data.density15 = value;
                                break;
                                case 'Pressure':
                                    if("BAR" == uoM.toUpperCase()){
                                        this.data.gasPressureBar = value;
                                    }else if("KG/CM2" == uoM.toUpperCase()){
                                        this.data.gasPressureKGCM2 = value;
                                    }
                                break;
                                case 'Gas Temperature':
                                    this.data.gasTemperature = value;
                                break;
                            }
                        })
                    } else {
                        if(Array.isArray(data)){
                            for(let i=0; i<data.length; i++){
                                this.$toast.add({detail: data[i].value, life:3000, severity:'error'});
                            }
                        }else{
                            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                        }
                    }
                });
            }
        },
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        }
    },  
}
</script>

<template>

    <Card>
        <template #content>
            <div class="grid formgrid" >
                <div class="col-12 lg:col-6 field">
                    <label :class="{'p-error':v$.data.tankCode.$invalid && submitted}">{{$t('calculatorInsertData.container')}}</label>
                        <GenericCustomAutocompleteV2
                            ref="tankAC"
                            class="w-full p-inputtext-sm"
                            v-model="data.tankCode"
                            name="tank-management-tank-combo"
                            :format="{ label: 'label', value: 'label' }"
                            api="masterdata/equipment-combo?getOnlyValid=true&type=SERB" />   
                        <div v-if="(v$.data.tankCode.$invalid && submitted) || v$.data.tankCode.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.tankCode.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div> 
                </div>  
                <div class="col-12 lg:col-6 field">
                    <label :class="{'p-error':v$.data.calculationDate.$invalid && submitted}">{{$t('calculatorInsertData.date_hour')}}</label>
                    <Calendar 
                        v-model="data.calculationDate"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="true" :hideOnDateTimeSelect="true"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                        class="w-full p-inputtext-sm " />
                        <div v-if="(v$.data.calculationDate.$invalid && submitted) || v$.data.calculationDate.$pending.$response">
                            <small class="p-error" v-for="error in v$.data.calculationDate.$silentErrors" :key="error.$validator">
                                {{$t(error.$message)}}
                            </small>
                        </div> 
                </div>
                
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.tempAmb')}}</label>
                    <InputNumber class="w-full p-inputtext-sm" v-model="data.environmentTemperature" :readonly="true" :minFractionDigits="2" :maxFractionDigits="2"/>
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.tempLiq')}}</label>
                    <InputNumber mode="decimal" :readonly="true" :minFractionDigits="2" :maxFractionDigits="2" class="w-full p-inputtext-sm"  v-model="data.temperature" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.density')}}</label>
                    <InputNumber  mode="decimal" :readonly="true" :minFractionDigits="4" :maxFractionDigits="4" class="w-full p-inputtext-sm" v-model="data.density15" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.level')}}</label>
                    <InputNumber class="p-inputtext-sm w-full" id="level"  v-model="data.productLevel" :readonly="true" />
                </div>
                <div class="col-12 lg:col-6 field">
                    <label >{{$t('calculatorTankDevelopment.gasPressure')}}</label>
                    <InputNumber class="w-full p-inputtext-sm"  v-model="data.gasPressureBar" :minFractionDigits="2" :maxFractionDigits="2" :readonly="true" />
                </div>
                <!-- <div class="col-12 lg:col-6 field">
                    <label >{{$t('calculatorTankDevelopment.gasPressureKGCM2')}}</label>
                    <InputNumber class="w-full p-inputtext-sm"  v-model="data.gasPressureKGCM2" :minFractionDigits="2" :maxFractionDigits="2" :readonly="true" />
                </div> -->
                <div class="col-12 lg:col-6 field">
                    <label>{{$t('calculatorTankDevelopment.gasTemperature')}}</label>
                    <InputNumber class="w-full p-inputtext-sm"  v-model="data.gasTemperature" :readonly="true" :minFractionDigits="2" :maxFractionDigits="2"/>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="grid">
                <div class="col-12 lg:col-4 xl:col-3" style="margin: 0 auto;">
                <Button :label="$t('btn.readPi')" icon="pi pi-upload" class="w-full m-2 p-button-sm" @click="importFromPI" :disabled="!uiPermissions('tankCalculatorPIButton').isEnabled" />
            </div>
        </div>
        </template>
    </Card>
</template>